import script from "./TaskEditorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEditorDialog.vue?vue&type=script&setup=true&lang=js"

import "./TaskEditorDialog.vue?vue&type=style&index=0&id=16d3e38c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d3e38c"]])

export default __exports__